// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search-section_wrapper__qhICY","wrapperV2":"search-section_wrapperV2__u2yoq"};